<template>
  <div class="hero-carousel">
    <div class="hero-carousel__gradient"></div>
    <transition name="fade">
      <div
        class="hero-carousel__image hero-carousel__image--one"
        :style="{backgroundImage: `url(${images.one})`}"
        v-if="activeIndex === 0 && !mediaSmall"
        key="one"
      >
        <svg viewBox="0 0 600 984" width="100%" v-if="mediaSmall" />
        <svg viewBox="0 0 3100 2000" width="100%" v-else />
      </div>
       <div
        class="hero-carousel__image hero-carousel__image--two"
        :style="{backgroundImage: `url(${images.two})`}"
        v-if="activeIndex === 1 || mediaSmall"
        key="two"
      >
        <svg viewBox="0 0 600 984" width="100%" v-if="mediaSmall" />
        <svg viewBox="0 0 3100 2000" width="100%" v-else />
      </div>
    </transition>
      <svg viewBox="0 0 600 984" width="100%" v-if="mediaSmall" />
      <svg viewBox="0 0 3100 2000" width="100%" v-else />
  </div>
</template>

<script>
/**
 * carousel component used as hero background
 */
import { mapState } from 'vuex';
import landingImage01 from './../assets/images/landing-image-1.jpg';
import landingImage02 from './../assets/images/landing-image-2.jpg';
import landingImageSmall01 from './../assets/images/landing-image-mobile-01.jpg';
import landingImageSmall02 from './../assets/images/landing-image-mobile-02.jpg';

export default {
  name: 'hero-carousel',
  props: {
    activeIndex: { type: Number, required: true }
  },
  computed: {
    images() {
      return {
        one: this.mediaSmall ? landingImageSmall01 : landingImage01,
        two: this.mediaSmall ? landingImageSmall02 : landingImage02,
      };
    },
    ...mapState('windowMedia', [
      'mediaSmall'
    ])
  },
};
</script>

<style lang="scss">
.hero-carousel {
  position: absolute;
  min-height: $size-height-carousel-min-height-base;
  width: 100%;
  top: 0;
  height: 100%;
  @include media(small) {
    min-height: $size-height-carousel-min-height-small;
  }
  &__image {
    position: absolute;
    width: 100%;
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    min-height: $size-height-carousel-min-height-base;
    height: 100%;
    @include media(small) {
      min-height: $size-height-carousel-min-height-small;
    }
    &--one {
      @include media(small) {
        background-position: center $size-background-position-carousel-one;
      }
    }
    &--two {
      @include media(small) {
        background-position: center $size-background-position-carousel-two;
      }
    }
  }
  &__gradient {
    position: absolute;
    bottom: 0;

    // TODO: make harsher when new images including fade come from @landon
    height: 25%;
    width: 100%;
    background: linear-gradient(to bottom,
      transparent 0%, $color-background-page-base 100%);

    @include media(small) {
      background: linear-gradient(to bottom,
      transparent 0%, $color-background-page-base 70%);
    }
    z-index: 2;
  }
}
</style>
